/** Read/write registration flow data in localStorage (design only). */
import { formatRegisterDobForApi } from "../Register/Register.validator";
import { clearInsuranceCardImages } from "./Insurance/insuranceCardImagesStore";

export const getRegistrationData = () => {
  const saved = localStorage.getItem("data");
  if (!saved) {
    return {};
  }
  try {
    return JSON.parse(saved);
  } catch {
    return {};
  }
};

export const updateRegistrationData = (updates) => {
  const current = getRegistrationData();
  localStorage.setItem("data", JSON.stringify({ ...current, ...updates }));
};

export const isRegistrationComplete = (data = getRegistrationData()) =>
  Boolean(data?.bookedAppointment);

export const clearRegistrationData = () => {
  clearInsuranceCardImages();
  localStorage.removeItem("data");
};

/** Clears no-preference flow state when the user picks a specific dietitian. */
export const clearNoPreferenceRegistrationState = () => ({
  noPreferenceSelectedRd: null,
  noPreferenceSelectedSlot: null,
  noPreferenceSlotData: null,
  noPreferenceRdList: null,
  noPreferenceTimeslotRequest: null,
  noPreferenceRdSlot: null,
  noPreferenceSlotsByKey: null,
  noPreferenceAppointmentWeek: null,
});

const isTruthyCardPresent = (value) =>
  value === true || value === 1 || value === "1" || value === "true";

export const isCardOnFileComplete = (data) =>
  Boolean(
    data?.cardStoredSetupIntentId ||
      data?.cardOnFile?.saved ||
      isTruthyCardPresent(data?.isCardPresent) ||
      isTruthyCardPresent(data?.savePaymentTypeResponse?.is_card_present) ||
      isTruthyCardPresent(data?.savePaymentTypeResponse?.isCardPresent)
  );

export const extractCardLastFour = (setupIntent, storeCardRes) => {
  const paymentMethod = setupIntent?.payment_method;
  if (typeof paymentMethod === "object" && paymentMethod?.card?.last4) {
    return paymentMethod.card.last4;
  }
  const responseData = storeCardRes?.data;
  return (
    responseData?.last_four ??
    responseData?.last4 ??
    responseData?.card_last_four ??
    null
  );
};

export const buildUnavailableStateLeadPayload = (data) => {
  if (
    !data?.firstName ||
    !data?.lastName ||
    !data?.email ||
    !data?.registrationCode ||
    !data?.dob ||
    !data?.zipCode ||
    !data?.password ||
    data?.categoryId === "" ||
    data?.categoryId == null
  ) {
    return null;
  }

  return {
    first_name: String(data.firstName).trim(),
    last_name: String(data.lastName).trim(),
    email: String(data.email).trim(),
    registration_code: String(data.registrationCode).toUpperCase().trim(),
    dob: formatRegisterDobForApi(data.dob),
    zipcode: String(data.zipCode).trim(),
    category_id: Number(data.categoryId),
    password: String(data.password),
    isCheckedAcknowledgements: Boolean(
      data.isCheckedAcknowledgements ?? data.acceptedTerms
    ),
  };
};
